module.exports = __webpack_public_path__ + "assets/3-tech-sales-career.116d6820.png";